// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"style__pageTitle__BqFyW","pageMenu":"style__pageMenu__FEn28","wrapper":"style__wrapper__E6sU6","builder":"style__builder__QialZ","player":"style__player__brZcx"};